import { createContext } from 'react';

export type PageWorkflowRouteSettings =
  | Record<
      string,
      (Diagonal.Workflows.Data.WorkflowRouteSettingsData & { origin?: string | null }) | undefined
    >
  | null
  | undefined;

export const WorkflowRouteSettingsContext = createContext<PageWorkflowRouteSettings>(null);
